<div #wrapper class="dropdown-content" [style.visibility]="visible ? 'visible' : 'hidden'">
  <ng-container *ngTemplateOutlet="dropdownItemsTemplate"></ng-container>
</div>
